// Header ligero para las páginas de contenido SEO (/menu, /ubicaciones,
// /contacto). No arrastra el carrito ni el estado de pedido (eso vive en la
// home interactiva "/"). Usa <Link> para que sean navegaciones SPA reales.
//
// Responsive: en desktop los enlaces van a la derecha del logo; en móvil pasan
// a una fila inferior con scroll horizontal (mismo patrón que el Header de la
// home) para no desbordar pantallas estrechas. Tap targets >=44px.

import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { businessInfo } from '../mock';

const navItems = [
  { to: '/', label: 'Inicio', end: true },
  { to: '/menu/', label: 'Menú' },
  { to: '/nosotros/', label: 'Nosotros' },
  { to: '/ubicaciones/', label: 'Ubicaciones' },
  { to: '/contacto/', label: 'Contacto' },
];

const linkClass = ({ isActive }) =>
  `min-h-[44px] inline-flex items-center px-3 text-sm md:text-base transition-colors ${
    isActive ? 'text-caramel font-semibold' : 'text-chocolate hover:text-caramel'
  }`;

const SiteHeader = () => (
  <header className="sticky top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
    <nav className="container mx-auto px-4 md:px-6 py-2 md:py-3">
      <div className="flex items-center justify-between gap-2">
        <Link to="/" className="flex items-center space-x-2 md:space-x-3 min-w-0">
          <img src="/assets/logo.png" alt="Brazolovers — pastelería en Quito" className="h-9 md:h-10 w-auto shrink-0" />
          <div className="flex flex-col min-w-0">
            <span className="text-lg md:text-2xl font-bold text-chocolate leading-tight truncate">{businessInfo.name}</span>
            <span className="hidden sm:block text-xs md:text-sm text-caramel truncate">{businessInfo.tagline}</span>
          </div>
        </Link>

        {/* Desktop: enlaces a la derecha */}
        <div className="hidden md:flex items-center gap-2 lg:gap-4">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className={linkClass}>
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>

      {/* Móvil: fila inferior con scroll horizontal */}
      <div className="md:hidden mt-1 -mx-1">
        <div className="flex items-center gap-1 overflow-x-auto scrollbar-hide px-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `min-h-[40px] inline-flex items-center whitespace-nowrap rounded-full px-3 text-sm transition-colors ${
                  isActive ? 'bg-cream text-caramel font-semibold' : 'text-chocolate hover:text-caramel'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>
    </nav>
  </header>
);

export default SiteHeader;
